export enum ExportType {
    REPORT = 'REPORT',
    EVENTS = 'EVENTS',
}

export enum ExportJobStatus {
    PENDING = 'PENDING',
    PROCESSING = 'PROCESSING',
    COMPLETED = 'COMPLETED',
    ERROR = 'ERROR',
}

export interface ExportDownload {
    blob: Blob;
    fileName?: string;
}

export interface ExportJob {
    id: string;
    createdAt: number;
    updatedAt: number;
    type: ExportType;
    status: ExportJobStatus;
    progress: number;
    totalItems: number;
    processedItems: number;
    failedItems: number;
    statusDetails: string | null;
    warnings: Record<string, unknown>[] | null;
    data: Record<string, unknown>;
}
